import React from 'react'
import cx from 'classnames'
import arrowUp from 'assets/icons/arrow-up.svg'
import { ArrowDownIcon, ArrowUpIcon, Icon } from 'components/shared/Icon/Icon'
import styles from './JobblinkOverview.module.scss'

const suppressFocusScroll = event => {
  if (event.button === 0) {
    event.preventDefault()
  }
}

export const DataTableColumnSort = ({
  isDescending,
  onAscending,
  onDescending,
}) => {
  const stopPropagation = event => {
    event.stopPropagation()
  }

  const isNeutral = isDescending === null

  if (isNeutral) {
    return (
      <div className={styles.dataTableSorting} onClick={stopPropagation}>
        <button
          type="button"
          className={styles.dataTableSortButtonNeutral}
          onMouseDown={suppressFocusScroll}
          onClick={onAscending}
          aria-label="Sort ascending"
        >
          <Icon
            icon={arrowUp}
            size={12}
            className={styles.dataTableSortIconNeutral}
          />
        </button>
        <button
          type="button"
          className={styles.dataTableSortButtonNeutral}
          onMouseDown={suppressFocusScroll}
          onClick={onDescending}
          aria-label="Sort descending"
        >
          <Icon
            icon={arrowUp}
            size={12}
            className={cx(
              styles.dataTableSortIconNeutral,
              styles.dataTableSortIconNeutralDown,
            )}
          />
        </button>
      </div>
    )
  }

  const isAscending = isDescending === false

  return (
    <div className={styles.dataTableSorting} onClick={stopPropagation}>
      <button
        type="button"
        className={styles.dataTableSortButtonActive}
        onMouseDown={suppressFocusScroll}
        onClick={isAscending ? onDescending : onAscending}
        aria-label={isAscending ? 'Sort descending' : 'Sort ascending'}
      >
        <Icon
          icon={isAscending ? ArrowUpIcon : ArrowDownIcon}
          size={12}
          className={styles.dataTableSortIconActive}
        />
      </button>
    </div>
  )
}
